module.exports = __webpack_public_path__ + "static/media/600dlevelcontent.2cf466e5.png";